"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = seempleObjectIterator;

// Symbol.iterator of Seemple.Object instances
function seempleObjectIterator() {
  var _this = this;

  var keys = this.keys();
  var i = 0;
  return {
    next: function next() {
      if (i > keys.length - 1) {
        return {
          done: true
        };
      }

      return {
        done: false,
        value: _this[keys[i++]] // eslint-disable-line no-plusplus

      };
    }
  };
}
//# sourceMappingURL=iterator.js.map